import { InputAdornment } from 'ui';

import { TextField, TextFieldProps } from '../TextField/TextField';

export type PercentageFieldProps = Omit<TextFieldProps, 'type'>;

export const PercentageField = ({ rules = {}, ...rest }: PercentageFieldProps) => {
  return (
    <TextField
      type="number"
      {...rest}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
        ...rest.InputProps,
      }}
      rules={{
        max: { message: 'Value must be at most 100', value: 100 },
        min: { message: 'Value must be at least 0', value: 0 },
        ...rules,
      }}
    />
  );
};
